import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function SociosCreate() {
  const { user } = useContext(AuthContext);
  const URL_SOCIOS = process.env.REACT_APP_URL_SOCIOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [participacion, setParticipacion] = useState(0);
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setName("");
  };

  const saveSocios = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_SOCIOS,
        {
          name,
          participacion,
          porRetirar: 0,
          realRetirado: 0,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Socio",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <h3 align="center">Crea una nueva Socio</h3>
        <Form onSubmit={saveSocios}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">
              Socio
            </Label>
            <Input
              type="text"
              name="email"
              
              value={name}
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            <Label className="mr-sm-2">Participacion</Label>
             <Input
              type="number"
              value={participacion}
              required
              onChange={(e) => {
                setParticipacion(e.target.value);
              }}
            />
          </FormGroup>
          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button color="danger" href="/MenuRetiros">
            Regresar
            </Button>
            </Row>
        </Form>
      </div>
    </>
  );
}

export default SociosCreate;
